// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3e80551d","952":"9c3851b6"}[chunkId] + ".chunk.js";
};